// extracted by mini-css-extract-plugin
export default {"Container":"main__Container__GXyZN","Image":"main__Image__Nwfht","Banner":"main__Banner__nSdgE","Particles":"main__Particles__Fhymj","Section":"main__Section__EGZw6"};